// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_f9-0";
export var fulfillmentPanelBody = "_f9-1";